export default {
    allDevices: [],
    allDevicesPagedWithLocations: [],
    beaconLogs: [],
    devicesSummary: '',
    devicesCampaigns: '',
    requestsByDevice: [],
    devicesStatusLogs: '',
    recentReports: []
}
